'use strict';

function DropdownController ($log, $scope, DropdownService) {

  var DEFAULTS = {
    $id: $scope.$id,
    group: 'site',
    show: false
  };

  angular.extend(this, DEFAULTS);

  this.init = function () {
    DropdownService.register(this.group, this);
  };

  this.close = function () {
    this.show = false;

    safeApply();

    DropdownService.closed(this.$id);
    $scope.$emit('dropdown:closed');
  };

  this.open = function () {
    this.show = true;

    safeApply();

    DropdownService.opened(this.$id);
    $scope.$emit('dropdown:opened');
  };

  this.toggleVisibility = function () {
    this.show = !this.show;
  };

  ///////////////////////////////////////////////////////////////////////////////////////////
  // Helpers
  ///////////////////////////////////////////////////////////////////////////////////////////


  /**
   * Used internally to create a function that will retrieve a given controller attribute 
   * for $watch
   * 
   * @param  {String} attr
   * @return {Fn}
   */
  var ctrlAttr = function (attr) {
    return function () {
      return this[attr];
    }.bind(this);
  }.bind(this);

  function safeApply () {
    if ($scope.$root.$$phase !== '$apply' && 
        $scope.$root.$$phase !== '$digest') {

      // use $scope.$digest because we only want to trigger watchers on the
      // current $scope (and children) rather than the entire $scope chain
      $scope.$digest();
    }
  }


  ///////////////////////////////////////////////////////////////////////////////////////////
  // Event Handlers
  ///////////////////////////////////////////////////////////////////////////////////////////

  var onDestroy = function () {
    DropdownService.unregister(this.group, this.$id);
    $log.info('Destroyed Dropdown: ' + this.group + ' ' + this.$id);
  }.bind(this);

  var onShowChange = function (show) {
    if (show) {
      this.open();
    } else {
      this.close();
    }
  }.bind(this);

  $scope.$on('$destroy', onDestroy);
  $scope.$watch(ctrlAttr('show'), onShowChange);
}

module.exports = DropdownController;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/dropdown/src/DropdownController.js